import { render, staticRenderFns } from "./shaparak-info.vue?vue&type=template&id=5aff1e82"
import script from "./shaparak-info.vue?vue&type=script&lang=js"
export * from "./shaparak-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports